import ParameterValidator from '@mvps-genesis/parameter-validator';

/*
 *--------------------------------------------------------------------------
 * PromoCodeEvents
 *--------------------------------------------------------------------------
 *
 * Event for Single Input Forms, to disable (or re-enable) the Submit button based on the the value of the input.
 * Example: Submit button is disabled until user types something into the input.
 *
 */
export default class PromoCodeEvents {

	/**
	 * Parameter Validator object
	 *
	 * @var	@mvps-genesis/parameter-validator
	 */
	#validator;

	/**
	 * Input Element
	 *
	 * @var Element
	 */
	input;

	/**
	 * Submit Element
	 *
	 * @var Element
	 */
	submitElement;

	/**
	 * Create a new SummaryEvents object
	 *
	 * @param	Element	input	Input to watch when filled out
	 * @param	Element	submitElement	Submit Element to enable/disable
	 *
	 */

	constructor (input, submitElement) {
		this.#validator = new ParameterValidator(this);
		this.input = this.#validator.isElement('input', input);
		this.submitElement = this.#validator.isElement('submitElement', submitElement);

		this.bindEvents();
	}

	bindEvents () {
		this.bindInput();
		this.inputChanged();
	}

	bindInput () {
		this.input.addEventListener('input', () => this.inputChanged(this.input, this.submitElement));
	}

	inputChanged () {
		if (!this.input.value) {
			this.submitElement.disabled = true;
			return;
		}

		this.submitElement.disabled = false;
	}

}
